require('./hireCardMaestroStep4.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @constants
const {
    SECOND_STEP,
    FOURTH_STEP,
    HYPHEN
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { MAESTRO_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    MAESTRO,
    messages: {MAESTRO_AND_GDPR}
} = require('constants/operationTypes');
const {
    R42_CARD_PRODUCT_ALIAS,
    R42_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');

class hireCardMaestroStep4 extends React.Component {

    componentDidMount() {
        const {
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
        } = this.props;
        const precontractualMailProductInfo = {
            productAlias: R42_CARD_PRODUCT_MIN_ALIAS,
            productName: R42_CARD_PRODUCT_ALIAS,
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardMaestro-hireCardMaestro_confirmationStepAgreementText');
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardNameSelector,
            immHireCardMaestro,
            immShippingAddress,
            originCountry,
        } = this.props;
        const selectedAccount = immHireCardMaestro.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        const addressValue = immShippingAddress.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddress, originCountry);

        return (
            <div className="hire-card-maestro-step-four__summary row">
                <div className="col-xs-3 print-label">
                    <div className="hire-card-maestro-step-four__summary-label">
                        <FormattedText value="hireCardMaestro-summarySelectedName" />
                    </div>
                    <div className="hire-card-maestro-step-four__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="hire-card-maestro-step-four__summary-label">
                        <FormattedText value="hireCardMaestro-summarySelectedAccount" />
                    </div>
                    <div className="hire-card-maestro-step-four__summary-value">
                        <span>{immAccount.get('alias')}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
                <div className="col-xs-5 print-label">
                    <div className="hire-card-maestro-step-four__summary-label">
                        <FormattedText value="hireCardMaestro-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-maestro-step-four__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardMaestro, operativeName, immPdfData } = this.props;
        const immStep = immHireCardMaestro.getIn(['steps', FOURTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardMaestro-hireCardMaestro_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardMaestro-step3CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName('print-title', 'hire-card-maestro-step-four__title')
        const hireCardSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-maestro-step-four__subtitle')
        const operationParams = [{
            serviceCode: MAESTRO
        },{
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];
        const preContractDocumentInfo = getCardsPreContractPdfData()['maestro_card'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-maestro-step-four__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardMaestroAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={this.props.handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={MAESTRO_AND_GDPR}
                />
            )
        }

        return (
            <article className="hire-card-maestro-step-four">
                <FormattedText
                    className={hireCardTitleClassName}
                    value="hireCardMaestro-step3Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className={hireCardSubTitleClassName}
                    value="hireCardMaestro-step3Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={MAESTRO_GDPR_PID} />
                <WebappRender>
                    <div className="hire-card-maestro-step-four__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                        />
                    </div>
                </WebappRender>
                <div className="hire-card-maestro-step-four__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="hireCardMaestro-addressHint" className="no-print-out"/>
                    </OKMessage>
                </div>
                {agreementCheckboxContent}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

hireCardMaestroStep4.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMaestro: PropTypes.object.isRequired,
    immPdfData: PropTypes.object,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    originCountry: PropTypes.string.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = hireCardMaestroStep4;
